// extracted by mini-css-extract-plugin
export default {"container":"Banar_container__z1sjQ","tel":"Banar_tel__jFDdS","social":"Banar_social__a37aM"};